import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Tooltip,
    Grid,
    IconButton
} from '@material-ui/core';
import config from "../../../config";
import AlertBox from '../../AlertBox.js';
import { useDispatch } from 'react-redux';
import { startLoader, stopLoader } from "../../../actions/loaderActions";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useHistory } from 'react-router-dom';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';

const animatedComponents = makeAnimated();
const emissionOptions = [
    { label: 'Fuel', value: 'Fuel' },
    { label: 'Electricity', value: 'Electricity' },
    { label: 'Others', value: 'Others' }
];

const ApiBaseUrl = config.NodeApiBaseUrl;
const laravelBaseUrl = config.laravelBaseUrl;

const getDefaultHeaders = () => ({
    "x-tenant-schema": "Amplo111",
    "x-user-id": localStorage.getItem("UserId") || ""
});

const getDefaultHeadersDBO = () => ({
    "x-tenant-schema": "Amplo111",
    "x-user-id": localStorage.getItem("UserId") || ""
});

const DataCategoryTab = () => {
    const [frameworks, setFrameworks] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [dataCategories, setDataCategories] = useState([]);
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const Userid = localStorage.getItem("UserId")
    const [formData, setFormData] = useState({
        name: '',
        frameworks: [],
        industries: [],
        emission: ''
    });
    const history = useHistory();
    const esgFrameworkOptions = [
        "BRSR", "CDP", "CDSB", "CSRD", "ESRS", "FFBB", "GRESB", "GRI",
        "ISO", "ISSB", "LkSG", "SBTi", "SASB", "TCFD", "TNFD", "UNGC", "WDI", "WEF"
    ].map(f => ({ label: f, value: f }));

    const [filterFramework, setFilterFramework] = useState(null);
    const [filterIndustry, setFilterIndustry] = useState(null);
    const [alert, setAlert] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const [previewModal, setPreviewModal] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    useEffect(() => {
        loadInitialData();
    }, []);

    const loadInitialData = async () => {
        dispatch(startLoader());
        setFrameworks(esgFrameworkOptions);

        try {
            const industryRes = await axios.get(`${laravelBaseUrl}industry-collection`, { headers: getDefaultHeaders() });
            const industryOptions = (industryRes.data?.data || []).map(i => ({
                label: i.valueToShow,
                value: i.valueToShow
            }));
            setIndustries(industryOptions);
            console.log('Formatted industries:', industryOptions);
        } catch (err) {
            console.error('Industry API failed', err);
            showAlert('error', 'Failed to load industries');

        }

        try {
            const categoryRes = await axios.get(`${ApiBaseUrl}getAllDataCategories`, { headers: getDefaultHeadersDBO() });
            setDataCategories(categoryRes.data || []);
        } catch (err) {
            console.error('Data Category API failed', err);
            showAlert('error', 'Failed to load data categories');
        }
        dispatch(stopLoader());
    };

    const handleOpen = (index = null) => {
        if (index !== null) {
            const dc = dataCategories[index];
            setEditIndex(index);
            setFormData({
                name: dc.name,
                frameworks: dc.frameworks.map(f => ({ label: f, value: f })),
                industries: dc.industries.map(i => ({ label: i, value: i })),
                emission: dc.emission_category
            });
        } else {
            setEditIndex(null);
            setFormData({ name: '', frameworks: [], industries: [], emission: '' });
        }
        setOpenModal(true);
    };

    const handleClose = () => {
        setOpenModal(false);
    };

    const handleSave = async () => {
        const payload = {
            name: formData.name.trim(),
            frameworks: formData.frameworks.map(f => f.value),
            industries: formData.industries.map(i => i.value),
            emission_category: formData.emission
        };

        if (!payload.name) return alert('Name is required');
        dispatch(startLoader());
        try {
            if (editIndex !== null) {
                await axios.put(`${ApiBaseUrl}createDataCategory/${dataCategories[editIndex].category_id}`, payload, {
                    headers: getDefaultHeadersDBO()
                });
                showAlert('success', 'Data Category updated successfully');
                dispatch(stopLoader());
            } else {
                await axios.post(`${ApiBaseUrl}createDataCategory`, payload, {
                    headers: getDefaultHeadersDBO()
                });
                dispatch(stopLoader());
                showAlert('success', 'Data Category created successfully');
            }
            await loadInitialData();
            handleClose();
        } catch (err) {
            dispatch(stopLoader());
            console.error('Save failed', err);
            showAlert('error', 'Failed to save data category');
        }
    };

    const handleDelete = async (index) => {
        const item = dataCategories[index];
        if (item.templates > 0) return showAlert('error', 'Cannot delete - templates exist');
        try {
            dispatch(startLoader());
            await axios.delete(`${ApiBaseUrl}deleteDataCategory/${item.category_id}`);
            await loadInitialData();
            dispatch(stopLoader());
            showAlert('success', 'Data Category deleted successfully');
        } catch (err) {
            dispatch(stopLoader());
            showAlert('error', 'Failed to delete data category');
        }
    };

    const filteredCategories = dataCategories.filter(cat => {
        const matchesFramework = !filterFramework || cat.frameworks.includes(filterFramework.value);
        const matchesIndustry = !filterIndustry || cat.industries.includes(filterIndustry.value);
        return matchesFramework && matchesIndustry;
    });

    const showAlert = (type, msg) => {
        setAlert({ open: true, message: msg, severity: type });
    };

    const handleteTemplateRedirection = () => {
        history.push(`/data-management/templates?section=3&userID=${Userid}`);
    };

    const handlePreview = (index) => {
        setPreviewData(dataCategories[index]);
        setPreviewModal(true);
    };


    return (
        <Box p={3}>

            <Grid container spacing={2} alignItems="center" style={{ margin: '12px 0' }}>
                {/* Filters on the left */}
                <Grid item xs={12} sm={9}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <Select
                                isClearable
                                options={frameworks}
                                placeholder="Filter by Framework"
                                value={filterFramework}
                                onChange={setFilterFramework}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Select
                                isClearable
                                options={industries}
                                placeholder="Filter by Industry"
                                value={filterIndustry}
                                onChange={setFilterIndustry}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {/* Button on the right */}
                <Grid item xs={12} sm={3} style={{ textAlign: 'right' }}>
                    <Button variant="contained" color="primary" onClick={() => handleOpen()}>
                        + Add Data Category
                    </Button>
                </Grid>
            </Grid>


            <Paper>
                <Table>
                    <TableHead>
                        <TableRow style={{ backgroundColor: '#3c4246', color: 'white' }}>
                            <TableCell style={{ color: 'white' }}><b>Data Category</b></TableCell>
                            <TableCell style={{ color: 'white' }}><b>Templates</b></TableCell>
                            <TableCell align="center" style={{ color: 'white' }}><b>Actions</b></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredCategories.map((cat, idx) => (
                            <TableRow key={cat.id}>
                                <TableCell>{cat.name}</TableCell>
                                <TableCell>
                                    <span
                                        onClick={handleteTemplateRedirection}
                                        style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                                    >
                                        {cat.templates}
                                    </span>
                                </TableCell>
                                <TableCell align="center">
                                    <Tooltip title="View">
                                        <IconButton onClick={() => handlePreview(idx)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Edit">
                                        <IconButton onClick={() => handleOpen(idx)}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title={cat.templates > 0 ? "Cannot delete: Templates exist" : "Delete"}>
                                        <span>
                                            <IconButton
                                                onClick={() => handleDelete(idx)}
                                                disabled={cat.templates > 0}
                                                style={{ color: cat.templates > 0 ? 'rgba(0, 0, 0, 0.26)' : '#f44336' }} // greyed out when disabled
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>

            <Dialog open={openModal} onClose={handleClose} fullWidth maxWidth={false}
                PaperProps={{
                    style: {
                        width: '800px',     // custom width
                        height: '500px'     // custom height
                    }
                }}>
                <DialogTitle disableTypography style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">{editIndex !== null ? 'Edit' : 'Add'} Data Category</Typography>
                    <IconButton aria-label="close" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent >
                    <TextField
                        label="Data Category Name"
                        fullWidth
                        required
                        margin="normal"
                        variant="outlined"
                        value={formData.name}
                        onChange={(e) => {
                            const value = e.target.value;
                            setFormData(prev => ({ ...prev, name: value }));
                        }}
                    />

                    <Typography variant="body2">Frameworks</Typography>
                    <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={frameworks}
                        value={formData.frameworks}
                        onChange={(selected) => {
                            setFormData(prev => ({ ...prev, frameworks: selected || [] }));
                        }}
                    />

                    <Typography variant="body2" style={{ marginTop: 16 }}>Industries</Typography>
                    <Select
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        isMulti
                        options={industries}
                        value={formData.industries}
                        onChange={(selected) => {
                            setFormData(prev => ({ ...prev, industries: selected || [] }));
                        }}
                    />


                    <Typography variant="body2" style={{ marginTop: 16 }}>Emission Category</Typography>
                    <Select
                        options={emissionOptions}
                        value={emissionOptions.find(e => e.value === formData.emission) || null}
                        onChange={(selected) => {
                            setFormData(prev => ({ ...prev, emission: selected?.value || '' }));
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
                </DialogActions>
            </Dialog>
            <AlertBox
                open={alert.open}
                onClose={handleClose}
                message={alert.message}
                severity={alert.severity}
            />
            <Dialog open={previewModal} onClose={() => setPreviewModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>Data Category Preview</DialogTitle>
                <DialogContent dividers>
                    {previewData && (
                        <Box>
                            <Typography variant="subtitle1" gutterBottom><b>Name:</b> {previewData.name}</Typography>

                            <Typography variant="subtitle2" gutterBottom><b>Frameworks:</b></Typography>
                            <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
                                {previewData.frameworks.map((f, i) => (
                                    <Chip key={i} label={f} color="primary" variant="outlined" />
                                ))}
                            </Box>

                            <Typography variant="subtitle2" gutterBottom><b>Industries:</b></Typography>
                            <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
                                {previewData.industries.map((ind, i) => (
                                    <Chip key={i} label={ind} color="secondary" variant="outlined" />
                                ))}
                            </Box>

                            <Typography variant="subtitle2" gutterBottom><b>Emission Category:</b></Typography>
                            <Chip
                                label={previewData.emission_category}
                                style={{ backgroundColor: '#3c4246', color: 'white' }}
                            />
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setPreviewModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
};

export default DataCategoryTab;